module.exports = __webpack_public_path__ + "fonts/RxZJdnzeo3R5zSexge8UUZBw1xU1rKptJj_0jans920.woff2";